// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uu5o","top":"styles_top__27Gjc"};